import '../../shared/error-boundary.ts';
/**
 * Tool page entry — text-diff
 */

import { diff } from '@bytario/core/text/diff';
import { createProgress, yieldToPaint } from '../../shared/progress.ts';

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[c]!);
}

const button = document.querySelector('#run') as HTMLButtonElement;
const MAX_DIFF_CHARS = 1_000_000;

button.addEventListener('click', async () => {
  const textA = (document.querySelector('#text-a') as HTMLTextAreaElement).value;
  const textB = (document.querySelector('#text-b') as HTMLTextAreaElement).value;
  if (!textA && !textB) return;
  if (textA.length > MAX_DIFF_CHARS || textB.length > MAX_DIFF_CHARS) {
    const el = document.querySelector<HTMLElement>('#result');
    if (el) { el.hidden = false; el.classList.add('is-error'); el.innerHTML = 'Each text input must be under 1 MB (1,000,000 characters). For larger files, use the API.'; }
    return;
  }
  const p = createProgress('#result', ['Comparing', 'Complete']);
  try {
    p.activate(0);
    await yieldToPaint();
    const encoder = new TextEncoder();
    const result = await diff(encoder.encode(textA), encoder.encode(textB));
    p.complete(0);

    p.activate(1);
    p.complete(1);
    if (result.identical) {
      p.finish('<p>The two texts are identical.</p>');
    } else {
      p.finish(
        '<div class="diff-stats"><span class="diff-add">+' + result.additions + ' additions</span> <span class="diff-del">-' + result.deletions + ' deletions</span></div>' +
        '<div class="diff-output"><pre>' + escapeHtml(result.diff) + '</pre></div>'
      );
    }
  } catch (e) {
    p.error(String(e));
  }
});
